"use client";
import { createContext, use } from "react";
//#region packages/@mantine/core/src/core/MantineProvider/Mantine.context.ts
const MantineContext = createContext(null);
function useMantineContext() {
	const ctx = use(MantineContext);
	if (!ctx) throw new Error("[@mantine/core] MantineProvider was not found in tree");
	return ctx;
}
function useMantineCssVariablesResolver() {
	return useMantineContext().cssVariablesResolver;
}
function useMantineClassNamesPrefix() {
	return useMantineContext().classNamesPrefix;
}
function useMantineStyleNonce() {
	return useMantineContext().getStyleNonce;
}
function useMantineWithStaticClasses() {
	return useMantineContext().withStaticClasses;
}
function useMantineIsHeadless() {
	return useMantineContext().headless;
}
function useMantineSxTransform() {
	return useMantineContext().stylesTransform?.sx;
}
function useMantineStylesTransform() {
	return useMantineContext().stylesTransform?.styles;
}
function useMantineEnv() {
	return useMantineContext().env || "default";
}
function useMantineDeduplicateInlineStyles() {
	return useMantineContext().deduplicateInlineStyles;
}
//#endregion
export { MantineContext, useMantineClassNamesPrefix, useMantineContext, useMantineCssVariablesResolver, useMantineDeduplicateInlineStyles, useMantineEnv, useMantineIsHeadless, useMantineStyleNonce, useMantineStylesTransform, useMantineSxTransform, useMantineWithStaticClasses };

//# sourceMappingURL=Mantine.context.mjs.map